import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GtmLoaderComponent } from '@app/core/components/gtm-loader/gtm-loader.component';
import { MaintenanceBannerComponent } from '@app/maintenance-banner/maintenance-banner.component';
import { HeaderComponent } from './header/header.component';
import { LoaderPageComponent } from './loader/loader.component';
import { AlertComponent } from './alert/alert.component';
import { TrackOutageSectionComponent } from './track-outage-section/track-outage-section.component';
import { RegistrationButtonComponent } from './registration-button/registration-button.component';
import { ButtonModule, InputModule, AppInsightsService } from '@eucoms/common-components';
import { RatingFeedbackComponent } from './rating-feedback/rating-feedback.component';
import { RatingScaleComponent } from './rating-feedback/rating-scale/rating-scale.component';
import { FeedbackComponent } from './rating-feedback/feedback/feedback.component';
import { ReportOutageQuestionComponent } from './report-outage-question/report-outage-question.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ButtonModule,
        FormsModule,
        ReactiveFormsModule,
        InputModule,
        TranslateModule
    ],
    declarations: [
        HeaderComponent,
        LoaderPageComponent,
        AlertComponent,
        GtmLoaderComponent,
        TrackOutageSectionComponent,
        RegistrationButtonComponent,
        ReportOutageQuestionComponent,
        MaintenanceBannerComponent,
        RatingFeedbackComponent,
        RatingScaleComponent,
        FeedbackComponent
    ],
    exports: [
        HeaderComponent,
        LoaderPageComponent,
        AlertComponent,
        GtmLoaderComponent,
        TrackOutageSectionComponent,
        RegistrationButtonComponent,
        ReportOutageQuestionComponent,
        MaintenanceBannerComponent,
        RatingFeedbackComponent,
        RatingScaleComponent,
        FeedbackComponent,
        TranslateModule,
    ],
    providers: [
        AppInsightsService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})

export class SharedModule { }
